<template>
<div class="container">
    <van-popup
    v-model="showContent"
    position="bottom"
    :style="{ height: '485px' }"
    >
    <div class="container">
         <p class="title">选择类型</p>
         <div class="item_list">
             <div class="item line_bottom" v-for="(item,index) in list" :key="index" @click="add(item,index)">
                  <p class="text">{{item.content}}</p>
                  <div :class = "active == index ? 'select-active':'select' "></div>
             </div>
         </div>
         <p class="confirm" @click="confirm">确定</p>
    </div>
    </van-popup>
</div>
</template>
<script>
    export default {
        data () {
            return {
                showContent: false,
                select: true,
                list: [
                    { content: '因侵害旅游者合法权益，被人民法院判处刑罚',type:1 },
                    { content: '在旅游经营活动中因妨害国（边）境管理受到刑事处罚',type:2 },
                    { content: '旅游市场主体发生重大安全事故，属于旅游市场主体主要责任',type:4 },
                    { content: '因侵害旅游者合法权益，造成游客滞留或者严重社会不良影响',type:5 },
                    { content: '法律法规规章规定的应当列入旅游市场黑名单的其他情形',type:7 },
                    { content: '人民法院认定的失信被执行人',type:8 }
                    // { content: '受到文化和旅游行政部门或者文化市场综合执法机构吊销旅行社业务经营许可证、导游证处罚 ',type:3 },
                    // { content: '连续12个月内两次被列入旅游市场重点关注名单 ',type:6 }
                ],
                active: -1,
                content: ''
            }
        },
        created () {

        },
        methods: {
            showTip () {
                this.showContent = true;
            },
            add (item, index) {
                this.active = index;
                this.content = item;
            },
            confirm () {
                this.$emit('getContent', this.content);
                this.showContent = false;
            }
        }
    }
</script>
<style scoped lang="less">
.container{
    width:100%;
    height:100%;
    padding:0 12px;
    box-sizing: border-box;

    .title{
        width:100%;
        text-align: center;
        font-size:16px;
        color:#333;
        padding:24px 0;
        font-weight: 700;
    }
    .item_list{
        width:100%;
        height:70%;
        overflow-y:auto;//关键
        .item{
            display:flex;
            align-items: center;
            flex-direction: row;
            justify-content: space-between;
            padding:16px 0;
            .text{
                font-size:14px;
                color:#333;
                width:84%;
                line-height: 1.3em;
            }
            .select{
                width:18px;
                height:18px;
                background-image: url('../../../assets/guideSystem/ic_ts_wgx@3x.png');
                background-size: 100% 100%;
            }
            .select-active{
                width:18px;
                height:18px;
                background-image: url('../../../assets/guideSystem/icon_ts_gx@3x.png');
                background-size: 100% 100%;
            }
        }
    }
    .confirm{
        width:100%;
        height:50px;
        background-color: #36B374;
        font-size:16px;
        color:#fff;
        text-align: center;
        line-height: 50px;
        border-radius: 3px;
        margin-top:10px;
    }
}
</style>
